import pdfPage21 from "../../assets/img/Relatorio-Perfil-Saude-Acknowledgment-Page-21.jpg";

export default function Page21() {
  return (
    <div>
      <img src={pdfPage21} alt={`Page 21 report Health Profile`} />
    </div>
  );
}
